<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_tracking === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="ma-4">
          <div class="pa-3">
            <div v-if="loading_data === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-row>
                <v-col class="mt-2 ">
                  <h2 class="font-22">รายการประเภทบัตรเครดิต</h2>
                </v-col>
                <v-col>
                  <div class="text-right mt-5">
                    <v-btn @click="credit_cilck_modal_add()" x-large class="grad-success-bg white--text btn_mobile"
                      style="font-size: 18px">เพิ่มประเภทบัตรเครดิต</v-btn>
                  </div>
                </v-col>
              </v-row>

              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
                  hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="data_test" :footer-props="footer_Props" mobile-breakpoint="0"
                :search="search">
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.card_no }}</td>
                    <td>{{ dataDetail.item.card_name_th }}</td>
                    <td>
                      {{ dataDetail.item.card_name_eng }}
                    </td>
                    <td class="pa-1">
                      <v-switch v-model="dataDetail.item.status"
                        @click="updateStatus(dataDetail.item.id, dataDetail.item.status)" color="success"></v-switch>
                    </td>
                    <td class="pa-1">

                      <v-btn small height="42" class="grad-warning-bg white--text mr-1 mb-1"
                        @click="credit_cilck_modal_edit(dataDetail.item.id)" title="แก้ไขข้อมูล">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>

                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>

        <!-- เพิ่มเครดิตการ์ด -->
        <v-dialog v-model="credit_modal_add" persistent max-width="600">
          <v-card class="pa-3">
            <v-form ref="form_add" @submit.prevent="credit_add">
              <div class="d-flex justify-space-between">
                <v-card-title class="font-22 bold pa-5">
                  เพิ่มประเภทบัตรเครดิต
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text class="pa-5">
                <v-row>
                  <!-- <v-col cols="12" class="py-1">
                    <div class="font-18">
                      <v-icon color="grey">mdi-credit-card-chip</v-icon> รหัสประะเภทบัตรเครดิต : 11
                    </div>
                  </v-col> -->
                  <v-col cols="12" class="py-3">
                    <v-text-field v-model="credit_input_th" prepend-inner-icon="mdi-credit-card" color="#86bc3a"
                      type="text" label="ชื่อบัตรเครดิต" :rules="[(v) => !!v || 'กรุณากรอกชื่อบัตรเครดิต']"
                      hide-details="auto" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-3">
                    <v-text-field v-model="credit_input_en" prepend-inner-icon="mdi-credit-card" color="#86bc3a"
                      type="text" label="ชื่อบัตรเครดิต (ภาษาอังกฤษ)"
                      :rules="[(v) => !!v || 'กรุณากรอกชื่อบัตรเครดิต (ภาษาอังกฤษ)']" hide-details="auto"
                      outlined></v-text-field>
                  </v-col>

                </v-row>

              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn :disabled="is_submit" type="submit" large class=" grad-success-bg white--text mr-3"
                  style="font-size: 18px">
                  บันทึก
                </v-btn>
                <v-btn large class=" grad-danger-bg white--text mr-3" @click="close_modal" style="font-size: 18px">
                  ยกเลิก
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>

        <!-- แก้ไขเครดิตการ์ด -->
        <v-dialog v-model="credit_modal_edit" persistent max-width="600">
          <v-card class="pa-3">
            <v-form ref="form_edit" @submit.prevent="credit_update">
              <div class="d-flex justify-space-between">
                <v-card-title class="font-22 bold pa-5">
                  แก้ไขประเภทบัตรเครดิต
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text class="pa-5">
                <v-row>
                  <!-- <v-col cols="12" class="py-1">
                    <div class="font-18">
                      <v-icon color="grey">mdi-credit-card-chip</v-icon> รหัสประะเภทบัตรเครดิต : 11
                    </div>
                  </v-col> -->
                  <v-col cols="12" class="py-3">
                    <v-text-field prepend-inner-icon="mdi-credit-card" color="#86bc3a" type="text" label="ชื่อบัตรเครดิต"
                      v-model="credit_modal_edit_card_name_th" :rules="[(v) => !!v || 'กรุณากรอกชื่อบัตรเครดิต']"
                      hide-details="auto" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-3">
                    <v-text-field prepend-inner-icon="mdi-credit-card" color="#86bc3a" type="text"
                      label="ชื่อบัตรเครดิต (ภาษาอังกฤษ)" v-model="credit_modal_edit_card_name_en"
                      :rules="[(v) => !!v || 'กรุณากรอกชื่อบัตรเครดิต (ภาษาอังกฤษ)']" hide-details="auto"
                      outlined></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn type="submit" large class=" grad-success-bg white--text mr-3" style="font-size: 18px">
                  บันทึก
                </v-btn>
                <v-btn large class=" grad-danger-bg white--text mr-3" @click="close_modal" style="font-size: 18px">
                  ยกเลิก
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>

      </v-card>

      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
// import {HTTP} from "@/axios";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Set_credit_information",
  data() {
    return {
      is_submit: false,
      loading_page: false,
      loading_data: false,
      credit_modal_add: false,
      credit_modal_edit: false,
      credit_modal_edit_card_name_th: '',
      credit_modal_edit_card_name_en: '',
      overlay: false,
      alert_success: false,
      alert_tracking: false,

      credit_input_th: '',
      credit_input_en: '',
      sortDesc: false,
      search: null,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },

      data_list: [],
      headers: [
        {
          text: 'รหัสบัตรเครดิต',
          value: 'credit_code',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อบัตรเครดิต',
          value: 'credit_name_th',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อบัตรเครดิต (ภาษาอังกฤษ)',
          value: 'credit_name_en',
          fixed: true,
          width: '150px',
        },
        {
          text: 'สถานะ',
          value: 'credit_status',
          fixed: true,
          sortable: false,

          width: '150px',
        },
        {
          text: 'จัดการ',
          value: 'credit_btn_edit',
          sortable: false,
          fixed: true,
          width: '150px',
        },
      ],
      data_test: [
        // {
        //   credit_code: '01',
        //   credit_name_th: 'Kbank',
        //   credit_name_en: 'VISA-MASTER-JCB',
        // },
        // {
        //   credit_code: '02',
        //   credit_name_th: 'Ksher alipay',
        //   credit_name_en: 'Ksher A',
        // },
        // {
        //   credit_code: '03',
        //   credit_name_th: 'Ksher We',
        //   credit_name_en: 'Ksher W',
        // },
      ],

    }
  },
  methods: {

    async updateStatus(id, status) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };

      HTTP_ARIN.post(`/creditcard/update`, { id: id, status: status }, config).then((res) => {
        if (res.data.successful === true) {
          this.alert_success = true
          setTimeout(() => { this.alert_success = false }, 2000)
        }
      });
    },
    credit_list() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/creditcard/list", config).then((res) => {
        if (res.data.successful === true) {
          this.data_test = res.data.data;
          for (let index = 0; index < this.data_test.length; index++) {
            if (this.data_test[index].status == 0) {
              this.data_test[index].status = 1
            } else {
              this.data_test[index].status = 0
            }
          }
        }
      });
    },
    credit_add() {
      if (this.$refs.form_add.validate()) {
        let data = {
          card_name_th: this.credit_input_th,
          card_name_eng: this.credit_input_en
        };

        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };

        this.is_submit = true;
        HTTP_ARIN.post("/creditcard/create", data, config).then(
          (res) => {
            if (res.data.successful === true) {
              this.alert_success = true
              this.credit_modal_add = false;
              this.credit_input_th = ''
              this.credit_input_en = ''
              this.credit_list()
              setTimeout(() => { this.alert_success = false, this.is_submit = false; }, 2000)
            } else {
              this.is_submit = false;
            }
          }
        );
      }
    },
    credit_update() {
      if (this.$refs.form_edit.validate()) {
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        let data = {
          id: this.credit_modal_edit_data.id,
          card_name_th: this.credit_modal_edit_card_name_th,
          card_name_eng: this.credit_modal_edit_card_name_en
        };
        this.is_submit = true;
        HTTP_ARIN.post("/creditcard/update", data, config).then(
          (res) => {
            if (res.data.successful === true) {
              this.alert_success = true
              this.credit_modal_edit = false
              this.credit_list()
              setTimeout(() => { this.alert_success = false, this.is_submit = false; }, 2000)
            } else {
              this.is_submit = false;
            }

          }
        );
      }

    },
    format_price: function (value) {
      return formatPrice(value)
    },
    credit_cilck_modal_add() {
      this.credit_modal_add = true
    },
    credit_cilck_modal_edit(id) {
      this.credit_modal_edit_data = this.data_test.find(v => v.id == id)
      this.credit_modal_edit_card_name_th = this.credit_modal_edit_data.card_name_th
      this.credit_modal_edit_card_name_en = this.credit_modal_edit_data.card_name_eng
      this.credit_modal_edit = true
    },
    detail_price_modal() {
      this.detail_price_success = true
    },
    go_page_edit_free() {
      this.$router.push('promotioneditposfree')
    },
    go_page_edit_price() {
      this.$router.push('promotioneditposprice')
    },
    close_modal() {
      this.credit_modal_add = false
      this.credit_modal_edit = false
    },
  },
  mounted() {
    this.credit_list()
  }
}
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}

.color-grey {
  color: #909090;
}</style>
